export const SystemSetting = {
    MsgTimeOut : 2500,
    dateFormat : "YYYY-MM-DD",
    rowInPage :10,
    mapKey : "AIzaSyASbUiCGYwyz0MsCk0hMrFzR6a1ksha2A8",
    publicUploadImage:""
};
export const AccountType = ["ADMIN","EMPLOYEE","CITIZEN"]
